import * as Yup from 'yup';

export const vehicleRegistrationNumberValidation = (t) =>
  Yup.string()
    .required(t('formUtils.vehicleRequired'))
    .min(4, t('formUtils.vehicleMin'))
    .max(10, t('formUtils.vehicleMax'))
    .matches(/^[A-Z0-9]+$/, t('formUtils.vehicleMatch'));
